// extracted by mini-css-extract-plugin
export var baseButton = "_od-0";
export var controlsArrowKeys = "_od-1";
export var controlsResetButton = "_od-2";
export var lightGameButton = "_od-4 _od-0";
export var playAgainButton = "_od-5 _od-0";
export var startGameButton = "_od-3 _od-0";